import { desckActionSelectors as selector } from "../Selectors/index";

export const deskReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET:
      return payload;

    default:
      return state;
  }
};
